export default function log(msg) {
    console.warn('[cap-ui-utils]', msg);
  }